import { useMutation } from '@tanstack/react-query';

import { PluginOlasioRequest } from '../../../../types/plugins';
import { handleError, handleSuccess } from '../../../../utils/admin';
import { useRequestConstructor } from '../../../hooks/useRequestConstructor';
import { getApiErrorMessage } from '../../../logic';
import { ApiErrorResponse } from '../../../types';
import { runOlasioRequest } from '../../requests/runOlasioRequest';

export const useRunOlasioRequest = () => {
  const { constructPost } = useRequestConstructor();
  const { mutateAsync, ...rest } = useMutation({
    mutationFn: (data: PluginOlasioRequest) =>
      runOlasioRequest(constructPost, data),
    onSuccess: () => handleSuccess('Report queued for processing.'),
    onError: (error: ApiErrorResponse) =>
      handleError(getApiErrorMessage(error, 'Olasio request failed')),
  });
  return { runOlasioRequest: mutateAsync, ...rest };
};
